// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__359TB","productName":"Table_productName__2GLtq"};